import { getOnlineAndOfflineService } from "modules/BookingCommon/common/utils"
import { ServicesGroup } from "utils/helpers/ServicesGroup"

export function getOnlineOrOfflineFromServices(
    servicesGroup: ServicesGroup,
    isOnline: boolean,
    unCheckSlots?: boolean
) {
    const { onlineService, offlineService } = getOnlineAndOfflineService(
        servicesGroup,
        unCheckSlots
    )
    if (onlineService && isOnline) {
        return "online"
    }
    if (offlineService && !isOnline) {
        return "offline"
    }
}
